<!--
 * @Descripttion: 
 * @version: 优惠券管理-修改
 * @Author: Jeson
 * @Date: 2021-06-07 09:41:25
 * @LastEditors: Jeson
 * @LastEditTime: 2021-06-15 11:17:08
-->
<template>
	<div>
		<iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
			<template #rightContent>
				<div class>
					<div class="bgfff pt30 pl10 pr10 coupon-list relative">
						<div class="tab-right-font">
              <span  slot="nav-right" class="tips-tab" v-if="tab_active ===2" ><van-icon name="warning-o" />列表仅展示7天以内过期的优惠券</span>
							<div>
								<van-image :src="require('@/assets/linquanzhongxin-icon.png')" width="14px" height="16px" class="mr5" />
								<router-link :to="LinkTypeCode.VoucherCenter" class="c222 f14 ihover">领券中心</router-link>
							</div>
							<div>
								<van-image :src="require('@/assets/wen-icon.png')" width="14px" height="14px" class="mr5" />
								<router-link
									:to="{ path: LinkTypeCode.HelpCenter, query: { activedParentKey: 3, activedKey: 31, Id: 'be462f34-116d-44f1-5078-08d811cf9ba3' } }"
									class="c222 f14 ihover"
								>
									优惠券使用说明
								</router-link>
							</div>
						</div>
						<van-tabs color="#0F6EE9"  title-active-color="#0F6EE9" animated v-model="tab_active" line-height="3" line-width="76" @change="handleTabsChange" :class="`tab${Number(tab_active + 1)}`" :border="false">
							<van-tab v-for="(item, index) in tabs" :key="index">
								<template #title>
									<span>{{ item.name }}</span>
									<span v-if="item.index" class="ml10">({{ item.index }})</span>
								</template>
								<div :class="{ bgfff: !coupons.length }" style="margin-top:30px">
                  
									<div class>
										<NewiCoupon :data="coupons" v-if="coupons.length" page="MyCoupon" />
										<EmptyControl style="padding-top: 100px;" v-if="!coupons.length && finished" type="coupon" text="暂无优惠券哦～"></EmptyControl>
									</div>
								</div>
							</van-tab>
						</van-tabs>
					</div>
					<iPagination :currentPage.sync="pageindex" :limit.sync="pageSize" :totalCount="totalCount" @turn="onLoad" small />
				</div>
			</template>
		</iMineTemplate>
	</div>
</template>
<script>
import { LinkTypeCode } from '@/dictionary/base.js';
import iDialog from '@/components/iDialog';
import NewiCoupon from '@/components/NewiCoupon';
import { BaseMixin } from '../../mixins/BaseMixin.js';
export default {
	name: 'MyCoupon',
	mixins: [BaseMixin],
	components: {
		NewiCoupon,
		iDialog
	},
	data() {
		return {
			LinkTypeCode,
			pageTitle: ['交易管理', '优惠券'],
			activedParentKey: 2,
			activedKey: 22,
			pageindex: 1,
			pageSize: 10,
			finished: false,
			coupons: [],
			totalCount: 0,
			tab_active: 0,
			tab_activeList: true,
			tabs: [
				{
					key: 0,
					name: '未使用',
					index: 0
				},
				{
					key: 1,
					name: '已使用',
					index: 0
				},
				{
					key: 2,
					name: '已过期',
					index: 0
				}
			]
		};
	},

	async mounted() {
		await this.onLoad();
		await this.getCount(
			Count => {
				this.tabs[1].index = Count;
			},
			2,
			false
		);
		await this.getCount(
			Count => {
				this.tabs[2].index = Count;
			},
			3,
			true
		);
	},
	methods: {
		async getCount(call, type, isOverdue) {
			const res = await this.getAction('/api_coupon/Coupon/GetMyCoupons', {
				keyword: '',
				couponHoldState: type,
				isOverdue: isOverdue,
				pageNo: 1,
				pageSize: this.pageSize
			});
			if (res.IsSuccess) {
				call && call(res.Count);
			}
		},
		// tab 切换
		async handleTabsChange() {
			this.tab_activeList = false;
			this.finished = false;
			this.coupons = [];
			this.pageindex = 1;
			await this.loadData();
			this.tab_activeList = true;
		},
		// 加载数据
		async onLoad() {
			await this.loadData();
		},
		async loadData() {
			this.$hys.openLoading();
			const res = await this.getAction('/api_coupon/Coupon/GetMyCoupons', {
				keyword: '',
				couponHoldState: this.tab_active + 1,
				isOverdue: this.tab_active == 2 ? true : false,
				pageNo: this.pageindex,
				pageSize: this.pageSize
			});
			this.$hys.clearLoading();
			this.totalCount = res.Count;
			if (this.pageindex == 1) {
				this.coupons = [];
			}
			if (res.IsSuccess && res.Data.length < this.pageSize) {
				this.finished = true;
			}
			if (res.IsSuccess) {
				this.tabs[this.tab_active].index = res.Count;
				let dataArr = [];
				if (res.Data) {
					res.Data.map(item => {
						let lrt = parseFloat(item.OutCouponIssueDto.DeductionLimit * 10)
							.toFixed(2)
							.toString();
						let l = {
							...item,
							Goods: item.OutCouponIssueDto.OutCouponLimitGoodsDtos,
							UseRequire: item.OutCouponIssueDto.OutCouponUseRequireDto,
							BeginTime: item.ValidityBeginTime,
							EndTime: item.ValidityEndTime,
							FailureDays: item.OutCouponIssueDto.FailureDays,
							DeductionMode: item.OutCouponIssueDto.DeductionMode, //指定金额1，指定比例2，全额抵扣3
							DeductionLimit: item.OutCouponIssueDto.DeductionLimit,
							LimitF: item.OutCouponIssueDto.DeductionMode == 2 ? (lrt.indexOf('.') == -1 ? lrt : lrt.substring(0, lrt.indexOf('.'))) : null,
							LimitL:
								item.OutCouponIssueDto.DeductionMode == 2 ? (lrt.indexOf('.') == -1 ? null : lrt.substring(lrt.indexOf('.'), lrt.length).replace(/0/, '')) : null
						};
						dataArr.push(l);
					});
				}
				this.coupons = dataArr;
			} else {
				this.$toast({ position: 'bottom', message: res.Msg });
				this.finished = true;
			}
		}
	}
};
</script>
<style lang="less" scoped>
.tips-tab{
  color: #0F6EEA;
  font-size: 12px;
  padding-left: 12px;
  position: absolute;
  left: -398px;
  display: block;
  i.van-icon{
    position: relative;
    top:2px;
    margin-right: 4px;
  }
}
/deep/.van-tabs__wrap {
			border-bottom: 1px solid #84B5F4;
}
.coupon-list {
	border-radius: 2px;
	border: 1px solid rgba(232, 232, 232, 1);
	width: 100%;
	box-sizing: border-box;
	padding-bottom: 30px;
	min-height: 668px;
	padding-right: 10px;

	/deep/.van-tabs {

	}

	/deep/.van-tab {
		justify-content: flex-start;
		flex: none;
    padding: 0 20px;
		align-items: flex-start;
    font-size: 16px;
    /deep/ .van-tabs__wrap{
      border-bottom: 1px solid #3183EC;
    }
	}

	.tab-right-font {
		position: absolute;
		top: 30px;
		right: 20px;
		z-index: 1;

		> div {
			display: inline-block;
			position: relative;
			line-height: 24px;
			margin-right: 40px;

			&:last-child {
				margin-right: 0;
			}

			/deep/.van-image {
				position: absolute;
				top: 50%;
				left: -20px;
				transform: translateY(-50%);
			}
		}
	}
}
</style>
